'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["ownerState", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { useMessageContext } from "./internals/MessageContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const MessageActions = /*#__PURE__*/React.forwardRef(function MessageActions(props, ref) {
  const _ref = props,
    {
      ownerState: ownerStateProp,
      slots,
      slotProps
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  const ownerState = useMessageContext();
  void ownerStateProp;
  const Actions = slots?.actions ?? 'div';
  const actionsProps = useSlotProps({
    elementType: Actions,
    externalSlotProps: slotProps?.actions,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    }
  });
  return /*#__PURE__*/_jsx(Actions, _extends({}, actionsProps));
});
if (process.env.NODE_ENV !== "production") MessageActions.displayName = "MessageActions";